"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FairPriceMethodEnum = void 0;
var FairPriceMethodEnum;
(function (FairPriceMethodEnum) {
    FairPriceMethodEnum["PE"] = "pe";
    FairPriceMethodEnum["FCF"] = "fcf";
    FairPriceMethodEnum["DCF"] = "dcf";
})(FairPriceMethodEnum = exports.FairPriceMethodEnum || (exports.FairPriceMethodEnum = {}));
//# sourceMappingURL=fair-price-method-enum.js.map